import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGustoCompany, IGustoMe } from 'components/domain/integration/gusto/types/types';
import { Nullable } from 'types/util/Nullable';

export interface IStoreGusto {
  company: Nullable<IGustoCompany>;
  me: Nullable<IGustoMe>;
  hasSignedTos: Nullable<boolean>;
}

export const initialState: IStoreGusto = {
  company: null,
  me: null,
  hasSignedTos: null,
};

const slice = createSlice({
  name: 'Gusto',
  initialState,
  reducers: {
    setGustoCompany: (state: IStoreGusto, payload: PayloadAction<Nullable<IGustoCompany>>) => {
      state.company = payload.payload;
      return state;
    },
    setGustoMe: (state: IStoreGusto, payload: PayloadAction<Nullable<IGustoMe>>) => {
      state.me = payload.payload;
      return state;
    },
    setGustoHasSignedTos: (state: IStoreGusto, payload: PayloadAction<boolean>) => {
      state.hasSignedTos = payload.payload;
      return state;
    },
  },
});

export const { setGustoCompany, setGustoMe, setGustoHasSignedTos } = slice.actions;
export default slice.reducer;
